<template>
  <section class="companies-section">
    <div class="header-container">
      <h1 class="section-title">{{ msg }}</h1>
    </div>

    <div class="content-container">
      <div class="search-action-container">
        <!-- Search bar -->
        <div class="search-container">
          <div class="search-input-wrapper">
            <div class="search-icon">
              <svg aria-hidden="true" class="search-icon-svg" fill="currentColor"
                  viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                      d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                      clip-rule="evenodd"></path>
              </svg>
            </div>
            <input 
              type="text" 
              id="simple-search"
              class="search-input"
              placeholder="Search companies..." 
              v-model="searchData.keyword" 
              v-on:keyup="getCompaniesList"
            >
          </div>
        </div>

        <!-- Add company button -->
        <button
          class="add-company-btn"
          v-b-modal.add-modal
        >
          <svg class="btn-icon" width="20" height="20" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                  stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <span class="btn-text">Add Company</span>
        </button>
      </div>

      <!-- Companies table -->
      <div class="table-container">
        <table class="companies-table">
          <thead>
            <tr>
              <th class="th-first">Logo</th>
              <th>Company Name</th>
              <th>Selected Plan</th>
              <th>Consulting Hours Total</th>
              <th>Consulting Hours Remaining</th>
              <th>Registered Date</th>
              <th class="th-last">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="comapanyListLength" v-for="r in comapanyList.data" v-bind:key="r.id" class="table-row">
              <td class="logo-cell">
                <img :src="path + r.company_logo" class="company-logo" alt="Company logo" />
              </td>
              <td class="company-name">{{ r.company_name }}</td>
              <td>{{ r.selected_plan_id }}</td>
              <td>{{ r.total_hours }}</td>
              <td>{{ r.remaining_hours }}</td>
              <td>{{ r.created_at | timeAgo }}</td>
              <td class="action-cell">
                <div class="action-buttons">
                  <button class="edit-btn" @click="getCompany(r)" v-b-modal.update-modal>
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.33301 2.66666H4.53301C3.4129 2.66666 2.85285 2.66666 2.42503 2.88464C2.0487 3.07639 1.74274 3.38235 1.55099 3.75867C1.33301 4.1865 1.33301 4.74655 1.33301 5.86666V11.4667C1.33301 12.5868 1.33301 13.1468 1.55099 13.5746C1.74274 13.951 2.0487 14.2569 2.42503 14.4487C2.85285 14.6667 3.4129 14.6667 4.53301 14.6667H10.133C11.2531 14.6667 11.8132 14.6667 12.241 14.4487C12.6173 14.2569 12.9233 13.951 13.115 13.5746C13.333 13.1468 13.333 12.5868 13.333 11.4667V8.66666M5.33299 10.6667H6.44935C6.77547 10.6667 6.93853 10.6667 7.09198 10.6298C7.22803 10.5972 7.35809 10.5433 7.47739 10.4702C7.61194 10.3877 7.72724 10.2724 7.95785 10.0418L14.333 3.66666C14.8853 3.11437 14.8853 2.21894 14.333 1.66666C13.7807 1.11437 12.8853 1.11437 12.333 1.66665L5.95783 8.04182C5.72723 8.27242 5.61193 8.38772 5.52947 8.52228C5.45637 8.64157 5.40249 8.77163 5.36983 8.90768C5.33299 9.06113 5.33299 9.22419 5.33299 9.55031V10.6667Z"
                        stroke="#0A0446" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>Edit</span>
                  </button>

                  <button class="delete-btn" @click="deleteCompany(r.id)">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 2H10M2 4H14M12.6667 4L12.1991 11.0129C12.129 12.065 12.0939 12.5911 11.8667 12.99C11.6666 13.3412 11.3648 13.6235 11.0011 13.7998C10.588 14 10.0607 14 9.00623 14H6.99377C5.93927 14 5.41202 14 4.99889 13.7998C4.63517 13.6235 4.33339 13.3412 4.13332 12.99C3.90607 12.5911 3.871 12.065 3.80086 11.0129L3.33333 4"
                        stroke="#6A6767" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span>Delete</span>
                  </button>

                  <div class="toggle-btn">
                    <a type="button" class="status-toggle" v-if="r.deleted_at" @click="activeInactiveCompany(r.id,1)">
                      <img src="../../assets/images/on.svg" alt="Activate" width="40" height="40" />
                    </a>
                    <a type="button" class="status-toggle" v-if="!r.deleted_at" @click="activeInactiveCompany(r.id,0)">
                      <img src="../../assets/images/off.svg" alt="Deactivate" width="40" height="40" />
                    </a>
                  </div>
                </div>
              </td>
            </tr>
            <tr v-if="!comapanyListLength">
              <td colspan="7" class="no-data">No Data Found</td>
            </tr>
          </tbody>
        </table>
        
        <pagination :data="comapanyList" @pagination-change-page="getCompaniesList" class="pagination-controls" />
      </div>
    </div>

    <!-- Add Modal -->
    <b-modal id="add-modal" size="lg" title="Add New Company" :hide-footer="hideFooter" no-fade no-enforce-focus>
      <Add :modalAdd="1" @company-added="companyAdded"></Add>
    </b-modal>

    <!-- Update Modal -->
    <b-modal id="update-modal" size="lg" title="Update Company" :hide-footer="hideFooter" no-fade no-enforce-focus>
      <form @submit="updateProfile" class="edit-form">
        <div class="form-row">
          <div class="form-group">
            <label for="companyname">Company/Organization Name <span class="required">*</span></label>
            <input type="text" class="form-control" id="companyname" placeholder="Company/Organization Name"
              v-model="chargebeeUser.companyname">
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="firstname">First Name <span class="required">*</span></label>
            <input type="text" class="form-control" id="firstname" placeholder="First Name"
              v-model="chargebeeUser.firstname" @keypress="alphabetsOnly">
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="lastname">Last Name <span class="required">*</span></label>
            <input type="text" class="form-control" id="lastname" placeholder="Last Name"
              v-model="chargebeeUser.lastname" @keypress="alphabetsOnly">
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="password">Password <span class="required">*</span></label>
            <input type="password" class="form-control" id="password" placeholder="Password"
              v-model="chargebeeUser.password">
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="remainingHours">Remaining Hours <span class="required">*</span></label>
            <input class="form-control" type="text" id="remainingHours" v-model="chargebeeUser.remainingHours" 
              @keypress="numbersOnly" placeholder="Remaining Hours" />
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="totalHours">Total Hours <span class="required">*</span></label>
            <input class="form-control" type="text" id="totalHours" v-model="chargebeeUser.totalHours" 
              @keypress="numbersOnly" placeholder="Total Hours" />
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="logo">Logo <span class="required">*</span></label>
            <input type="file" id="logo" ref="file" class="form-control file-input" 
              accept=".jpeg, .jpg, .png" @change="onFileChange">
          </div>
        </div>
        
        <div class="form-row" v-if="chargebeeUser.uploadedLogo">
          <div class="form-group">
            <label>Uploaded Logo</label>
            <div class="logo-preview">
              <img :src="path+chargebeeUser.uploadedLogo" alt="Company logo" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label for="duration">General Learning Plan Interval Duration</label>
            <select id="duration" class="form-control" v-model="chargebeeUser.duration">
              <option value="">--Select--</option>
              <option value="1">1 Day</option>
              <option value="2">2 Days</option>
              <option value="3">3 Days</option>
              <option value="21">3 Weeks</option>
              <option value="28">4 Weeks</option>
              <option value="35">5 Weeks</option>
              <option value="42">6 Weeks</option>
              <option value="56">8 Weeks</option>
              <option value="70">10 Weeks</option>
              <option value="84">12 Weeks</option>
            </select>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label for="learning_plan_start_date">General Learning Plan Start Date</label>
            <input type="date" id="learning_plan_start_date" class="form-control"
              placeholder="Learning plan start date" v-model="chargebeeUser.learning_plan_start_date">
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="update-btn" :disabled="chargebeeUser.disabled">
            <span v-if="chargebeeUser.disabled">Updating...</span>
            <span v-else>Update</span>
          </button>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
/* eslint-disable */
import Add from '../common/companies/Add.vue'
import Api from '../../router/api'
import AppMixin from '../../mixins/AppMixin'
import CustomPagination from '../common/CustomPagination.vue'

export default {
  name: 'Companies',
  mixins: [AppMixin],
  components: { 
    Add,
    CustomPagination
  },
  data() {
    return {
      hideFooter: true,
      msg: 'Companies',
      comapanyList: {},
      comapanyListLength: 0,
      path: '',
      searchData: {
        keyword: ''
      },
      updateData: {
        companyId: '',
        remainingHours: '',
        disabled: false
      },
      chargebeeUser: {
        'id': '',
        'companyname': '',
        'password': '',
        'firstname': '',
        'lastname': '',
        'logo': '',
        'uploadedLogo': '',
        'domain': '',
        'remainingHours': '',
        'totalHours': '',
        'disabled': false,
        'duration': '',
        "learning_plan_start_date": '',
      },
    }
  },
  components: { Add },
  methods: {
    // Handle the company-added event emitted from Add component
    companyAdded: function() {
      // Close the add modal
      this.$bvModal.hide('add-modal');
      // Refresh the companies list
      this.getCompaniesList();
    },
    getCompany: function (r) {
      let that = this
      that.chargebeeUser.id = r.id
      that.chargebeeUser.companyname = r.company_name
      that.chargebeeUser.password = r.password
      that.chargebeeUser.firstname = r.first_name
      that.chargebeeUser.lastname = r.last_name
      that.chargebeeUser.remainingHours = r.remaining_hours
      that.chargebeeUser.totalHours = r.total_hours
      that.chargebeeUser.uploadedLogo = r.company_logo
      that.chargebeeUser.duration = r.duration
      that.chargebeeUser.learning_plan_start_date = r.learning_plan_start_date
    },
    activeInactiveCompany: function (id, status) {
      let st = '';
      let st1 = '';
      if (status) {
        st = "Reactive"
        st1 = "Reactivated"
      } else {
        st = "Deactivate"
        st1 = "Deactivated"
      }
      let that = this
      this.$swal({
        title: 'Are you sure?',
        text: 'You want to ' + st + ' this company',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes ' + st + ' it!',
        cancelButtonText: 'No',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          Api.activeInactiveCompany(id, status).then(response => {
            this.$swal({
              icon: "success",
              title: "Success",
              text: "Company " + st1 + ' successfully',
              showConfirmButton: true
            }).then(function () {
              that.getCompaniesList()
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "error",
              text: error.response.data.message,
              showConfirmButton: true
            }).then(function () {
            });
          });
        }
      });
    },
    getCompaniesList: function (page = 1) {
      let that = this
      Api.getCompaniesList2(page, that.searchData).then(response => {
        that.comapanyList = response.data.res
        that.comapanyListLength = that.comapanyList.data.length
        that.path = response.data.path
      }).catch((error) => {
        this.$swal({
          icon: 'error',
          title: 'error',
          text: error.response.data.message,
          showConfirmButton: true
        }).then(function () {
        })
      })
    },
    onFileChange: function () {
      let that = this
      that.chargebeeUser.logo = that.$refs.file.files[0]
    },
    updateProfile: function (e) {
      let that = this
      e.preventDefault()
      const formData = new FormData()
      formData.append('id', that.chargebeeUser.id)
      formData.append('company_logo', that.chargebeeUser.logo)
      formData.append('company_name', that.chargebeeUser.companyname)
      formData.append('first_name', that.chargebeeUser.firstname)
      formData.append('last_name', that.chargebeeUser.lastname)
      formData.append('password', that.chargebeeUser.password)
      formData.append('remaining_hours', that.chargebeeUser.remainingHours)
      formData.append('total_hours', that.chargebeeUser.totalHours)
      formData.append('duration', that.chargebeeUser.duration)
      formData.append('learning_plan_start_date', that.chargebeeUser.learning_plan_start_date)

      let headers = {
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*'
      }
      that.chargebeeUser.disabled = true
      Api.updateProfileCompany(formData, headers).then(response => {
        this.$swal({
          icon: 'success',
          title: 'Success',
          text: 'Profile Updated Successfully',
          showConfirmButton: true
        }).then(function () {
          that.chargebeeUser.disabled = false
          that.$bvModal.hide('update-modal')
          that.getCompaniesList()
        })
      }
      ).catch((error) => {
        that.chargebeeUser.disabled = false
        this.$swal({
          icon: 'error',
          title: 'error',
          text: error.response.data.message,
          showConfirmButton: true
        })
      })
    },
    deleteCompany: function (id) {
      let that = this
      this.$swal({
        title: 'Are you sure?',
        text: 'All the related info will be deleted, you wont be able to revert !',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          Api.deleteCompany(id).then(response => {
            this.$swal({
              icon: 'success',
              title: 'Success',
              text: 'Company deleted successfully',
              showConfirmButton: true
            }).then(function () {
              that.getCompaniesList()
            })
          }).catch((error) => {
            this.$swal({
              icon: 'error',
              title: 'error',
              text: error.response.data.message,
              showConfirmButton: true
            }).then(function () {
              that.todo.disabled = false
            })
          })
        }
      })
    },
  },
  mounted() {
    this.getCompaniesList()
  }
}
</script>

<style scoped>
.companies-section {
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 2rem;
}

.header-container {
  background-color: white;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e9ecef;
}

.section-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #090446;
  text-transform: uppercase;
  margin: 0;
}

.content-container {
  padding: 1.5rem 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.search-action-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.search-container {
  flex: 1;
  max-width: 450px;
}

.search-input-wrapper {
  position: relative;
  width: 100%;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
}

.search-icon-svg {
  width: 18px;
  height: 18px;
}

.search-input {
  width: 100%;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border: 1px solid #ced4da;
  border-radius: 8px;
  font-size: 0.95rem;
  color: #212529;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.search-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.add-company-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0A0446;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}

.add-company-btn:hover {
  background-color: #080339;
}

.btn-icon {
  margin-right: 8px;
}

.table-container {
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.companies-table {
  width: 100%;
  border-collapse: collapse;
}

.companies-table th,
.companies-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #e9ecef;
}

.companies-table th {
  background-color: #0A0446;
  color: white;
  font-weight: 600;
  font-size: 0.85rem;
  text-transform: uppercase;
}

.companies-table td {
  color: #333;
  font-size: 0.9rem;
}

.th-first {
  border-top-left-radius: 8px;
}

.th-last {
  border-top-right-radius: 8px;
}

.table-row:hover {
  background-color: #f8f9fa;
}

.logo-cell {
  width: 100px;
}

.company-logo {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  object-fit: cover;
}

.company-name {
  font-weight: 600;
  color: #0A0446;
}

.action-cell {
  width: 300px;
}

.action-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-btn,
.delete-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0.5rem 0.75rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid #e9ecef;
  background-color: white;
  transition: all 0.15s ease-in-out;
}

.edit-btn {
  color: #0A0446;
}

.edit-btn:hover {
  background-color: #f0f0f7;
}

.delete-btn {
  color: #6A6767;
}

.delete-btn:hover {
  background-color: #f8f8f8;
}

.toggle-btn {
  display: flex;
  align-items: center;
}

.status-toggle {
  cursor: pointer;
}

.no-data {
  text-align: center;
  color: #6c757d;
  padding: 2rem !important;
  font-style: italic;
}

.pagination-wrapper {
  padding: 1.5rem;
  display: flex;
  justify-content: center;
}

.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-controls .pagination {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 0.25rem;
}

.pagination-controls .page-item {
  margin: 0 2px;
}

.pagination-controls .page-link {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  padding: 0.25rem 0.75rem;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  background-color: white;
  color: #0A0446;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.pagination-controls .page-link:hover {
  background-color: #f8f9fa;
  border-color: #dee2e6;
  color: #0A0446;
}

.pagination-controls .page-item.active .page-link {
  background-color: #0A0446;
  border-color: #0A0446;
  color: white;
}

.pagination-controls .page-item.disabled .page-link {
  color: #6c757d;
  pointer-events: none;
  background-color: #fff;
  border-color: #dee2e6;
  opacity: 0.65;
}

/* Modal Form Styles */
.edit-form {
  padding: 1rem 0;
}

.form-row {
  margin-bottom: 1rem;
}

.form-group {
  width: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #212529;
}

.required {
  color: #dc3545;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.75rem;
  font-size: 0.95rem;
  color: #495057;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 6px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  outline: 0;
}

.file-input {
  padding: 0.5rem;
}

.logo-preview {
  margin-top: 0.5rem;
}

.logo-preview img {
  width: 75px;
  height: 75px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid #e9ecef;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

.update-btn {
  background-color: #0A0446;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s ease-in-out;
}

.update-btn:hover:not(:disabled) {
  background-color: #080339;
}

.update-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/Companies.vue